<mat-form-field appearance="outline">
  <mat-label>{{'common_country' | translate}}</mat-label>
  <mat-select
    [formControl]="selectedCountry"
    disableOptionCentering
    panelClass="offsetPanel">
    @for (country of countries$ | async; track country) {
      <mat-option [value]="country">
        {{ country.name }}
      </mat-option>
    }
  </mat-select>
  <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
</mat-form-field>
